export { default as ChartPieIcon } from './ChartPieIcon';
